import { get } from "lodash";
import Select, { MultiValue } from "react-select";
import { MultipleChoiceFieldType } from "../../types/feedbackFields.types";
import { FieldProps } from "../fields.types";
import "./MultipleSelectField.scss";

function ensureArray<T>(value: T | T[] | undefined | null): T[] {
  if (!value) return [];
  if (!Array.isArray(value)) return [value];
  return value;
}

const MultipleSelectField = ({ field, data, onChange }: { field: MultipleChoiceFieldType } & FieldProps) => {
  const { _id, name, choices, required, selectProps = {} } = field;
  const id = _id || name;
  const values = ensureArray(get(data, id, []));

  const onLocalChange = (newValues: MultiValue<{ value: string }>) => {
    onChange(
      id,
      newValues?.map((v) => v.value)
    );
  };

  const options = choices.map((choice, index) => {
    const { value, text } = choice;
    const inputValue = value || text;

    return {
      value: inputValue,
      label: inputValue,
    };
  });

  const selectedValues = options.filter((o) => values.some((v: string) => o.value === v));

  return (
    <div id={id} className="feedback-multiselect">
      <Select
        onChange={onLocalChange}
        value={selectedValues}
        options={options}
        isMulti
        closeMenuOnSelect={false}
        placeholder={false}
        required={required}
        {...selectProps}
      />
    </div>
  );
};
export default MultipleSelectField;
